import * as Toast from '@radix-ui/react-toast';

export default Toast;
